import { WrappedTokenInfo } from 'state/lists/wrappedTokenInfo'
import { isLPToken } from 'utils/isLPToken'

/** ---- Helpers ---- **/
const EXCLUDE_FROM_MAIN = ['legacy', 'rwa', 'island', 'bault', 'charm', 'v2'] // tags to keep out of Main (including rwa due to low liq)

const hasAnyTag = (token: WrappedTokenInfo) => (token.tags ?? []).length > 0

const hasAnyExcludedTag = (token: WrappedTokenInfo) => (token.tags ?? []).some((t) => EXCLUDE_FROM_MAIN.includes(t.id))

const isNative = (token: WrappedTokenInfo) => token.isNative

const hasTag = (ids: readonly string[]) => (token: WrappedTokenInfo) =>
  (token.tags ?? []).some((t) => ids.includes(t.id))

// Majors = blue chips and assets tracking ETH or BTC
const CATEGORY_TAG_IDS = {
  rwa: ['rwa'],
  usd: ['usd'],
  majors: ['major', 'eth', 'btc'],
} as const

/** List tags that mirror a category tab, in badge priority order. */
export const CATEGORY_TAGS: readonly string[] = Object.values(CATEGORY_TAG_IDS).flat()

/** ---- Filters ---- **/
export const filters = {
  // Main = native OR has *any* tag, but no excluded tags
  main: (token: WrappedTokenInfo) => (isNative(token) || hasAnyTag(token)) && !hasAnyExcludedTag(token),

  lp: (token: WrappedTokenInfo) => isLPToken(token),

  rwa: hasTag(CATEGORY_TAG_IDS.rwa),

  usd: hasTag(CATEGORY_TAG_IDS.usd),

  majors: hasTag(CATEGORY_TAG_IDS.majors),
}
